import React from 'react'
import { ditto as dittoStatistics } from '../ditto/register.statistics'
import { ditto } from '../ditto/register.trans'

const Statistics = ({ opts = {}, data = [], extCloumns = [] }) => {
  const Widget = opts && dittoStatistics.render(opts.type)
  const finalData = (data || []).map((item) => {
    const obj = {}
    extCloumns.forEach((v) => {
      const arr = []
      item[v.slug].forEach((s) => {
        const { value } = ditto.transform(v.type, s) || {}
        arr.push(value)
      })
      obj[v.slug] = arr.join('、')
    })

    return { ...obj, ...item }
  })

  if (!Widget) {
    return null
  }
  return (
    <div className="w-full" style={{ height: 'calc(100% - 50px)' }}>
      <Widget opts={opts} data={finalData} extCloumns={extCloumns} />
    </div>
  )
}
export default Statistics
